import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useSubmotive4Form } from './hook';
import { Submotive4Data } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    SUBMOTIVE4,
    SUBMOTIVE4_DETAIL,
    SUBMOTIVE4_EDIT,
    SUBMOTIVE4_NEW,
} from '../../../../../routes/paths';
import { Submotive4ParamsHistorical } from '../historical';

export const Submotive4Form = () => {
    const {
        submotive4,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikSubmotive4Data,
        submotive4Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive4Form();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    submotive4 && submotive4.id
                        ? 'Editar submotivo 4'
                        : 'Crear submotivo 4'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive4?.id || ''}
                        buttonCreate={{
                            show: Boolean(submotive4?.id),
                            route: SUBMOTIVE4_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE4,
                        }}
                        buttonUpdate={{
                            show: true,
                            route: SUBMOTIVE4_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE4_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive4?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <Submotive4ParamsHistorical
                        historical={submotive4Historical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <Submotive4Data
                data={submotive4}
                onChangeFormik={(formik) => setFormikSubmotive4Data(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
